import { Helmet } from 'react-helmet-async';

/**
 * Composant optimisé pour ajouter les resource hints critiques
 * Améliore FCP, LCP et réduit le temps de connexion
 */
export const OptimizedResourceHints = () => {
  return (
    <Helmet>
      {/* DNS Prefetch pour résolution DNS précoce - domaines critiques uniquement */}
      <link rel="dns-prefetch" href="//erqsoqulvuxrhsokiarz.supabase.co" />
      <link rel="dns-prefetch" href="//fonts.gstatic.com" />
      
      {/* Preconnect pour établir les connexions tôt (DNS + TCP + TLS) - limité aux plus critiques */}
      <link rel="preconnect" href="https://erqsoqulvuxrhsokiarz.supabase.co" crossOrigin="anonymous" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossOrigin="anonymous" />
      
      {/* Preload du logo critique pour LCP avec fetchpriority high */}
      <link 
        rel="preload" 
        href="/assets/logo.png" 
        as="image" 
        type="image/png"
        fetchPriority="high"
      />
      
      {/* Preload police critique Orbitron */}
      <link
        rel="preload"
        href="https://fonts.gstatic.com/s/orbitron/v31/yMJMMIlzdpvBhQQL_SC3X9yhF25-T1nyGy6BoWgz.woff2"
        as="font"
        type="font/woff2"
        crossOrigin="anonymous"
      />
    </Helmet>
  );
};
